import { render, staticRenderFns } from "./Remuneracion.vue?vue&type=template&id=032df32f&"
import script from "./Remuneracion.vue?vue&type=script&lang=js&"
export * from "./Remuneracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports